import React, { useState } from "react";
import store from "@/redux/store";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { EyeIcon } from '@heroicons/react/24/outline';
import Drawer from "@/controllers/Drawer";
import {removeCustomer} from "@/reducers/Customer";
import { loadCustomer, addCustomer, unsetSelected } from '@/reducers/Customer'
import { TablePagination } from "@/components/holders/TablePagination";
import {showTimeRegistration, initTimeRegistration, DELETE_TIME_REGISTRATION, exportRegistration, LOAD_TIME_REGISTRATIONS} from "@/reducers/TimeRegistration";
import { TimeRegistrationModel } from "@/models/TimeRegistration.ts";
import {showConfirmModal, hideModal} from "@/reducers/ModalPopup";    
import { SelectBox } from "@/components/holders/SelectBox";
import { checkAbility } from "@/Events/CheckAbilityEvent";

export function Overview({...props}) {
    let tableItems = (props.data && props.data.data) ? props.data.data : [];
    let filter_customers = (props.filters && props.filters["customers"]) ? props.filters["customers"] : [];
    
    //const {items} = data;
    const [selectedData, setSelectedData] = useState(null);
        
const showPreview = (event, item) => {
    event.preventDefault();
    store.dispatch(loadCustomer(item.key));
    setSelectedData({data: item, click: new Date()});
    
    return false;
  }
const editTimeRegistration = (item) => {
    store.dispatch( showTimeRegistration(item));
}
const removeHandler = (event, item) => {
    event.preventDefault();
    
    store.dispatch(showConfirmModal({item: item, action: confirmedRemoveHandler}));
    
    //store.dispatch(removeCustomer(item.key));
    
    return false;
  }
const exportEventHandler = (event) => {
    event.preventDefault();
    
    store.dispatch(exportRegistration({}));
    
    //store.dispatch(removeCustomer(item.key));
    
    return false;
    
}
const confirmedRemoveHandler = (props) => {
    store.dispatch( DELETE_TIME_REGISTRATION(props.item));
    store.dispatch(hideModal());
}

const setValueCombobox = (name, val) => {
    store.dispatch(LOAD_TIME_REGISTRATIONS({filter: {name: name, val: val}}));
}
    const showTimeRegistrationPanelEvent = (event) => {
        store.dispatch( initTimeRegistration());
    }


//changeEvent={(name, val) => setValueCombobox(name,val)}
  return (
    <>


    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">Tijd registratie</h1>
        </div>
        
      </div>
      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
           <div className="my-2 flex sm:flex-row flex-col">
                 <div className="mt-3 sm:ml-4 sm:mt-0">
                    <div className="sm:col-span-3">
                        <SelectBox className="" label="Filteren op klant" name="customer" data={filter_customers} boxfield="name"  placeHolder="Selecteer een klant" changeEvent={(name, val) => setValueCombobox(name,val)}/> 
                    </div>
                    <Link onClick={(event) => {showTimeRegistrationPanelEvent(event)}} type="button" className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                        Tijd registreren
                    </Link>
                 
                    <Link onClick={(event) => {exportEventHandler(event)}} type="button" className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                        Exporteren
                    </Link>
                </div>

            </div>        
            <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Dossier/Klant
                  </th>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                    Organisatie sector<br/>
                    Afdeling
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Tijd & Registratie datum
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Type werk
                  </th>
                  <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                    <span className="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {tableItems && tableItems.map((item) => (
                  <tr key={item.key}>
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                        <div className="gap-x-6">
                            {item?.dossier_key && item.dossier_key.customer &&  
                                <span className="block">{item.dossier_key.customer.name}</span>
                            }
                            {item?.dossier_key && 
                                <span className="block">{item.dossier_key.name}</span>
                            }
                            
                            {item.company && item.company.name}
                            {item.tenant && item.tenant.name}
                      </div>
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <h3 className="mt-2 text-sm font-semibold text-gray-900">{item.sector.name}</h3><span>{item.department.name}</span>
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <h3 className="mt-2 text-sm font-semibold text-gray-900">{item.hours} uur - {item.minutes} minuten</h3><span>{item.worklog_date}</span>
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        { item?.worktype && item?.worktype?.name &&
                        <h3 className="mt-2 text-sm font-semibold text-gray-900">{(item?.worktype?.name) ? item.worktype.name : "Onbekend"}</h3>
                        }
                    </td>
                    <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0 mr-5">
                    <>
                    {item.id != 0 && checkAbility('timeregistration', 'delete') && 
<></>
                      }
                                <Link 
                                onClick={(e) => {removeHandler(e, item);}}
                                className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 mr-5">
                        Verwijderen<span className="sr-only">, {item.name}</span>
                      </Link>
                                <Link onClick={(event) => editTimeRegistration(item)} className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 ">
                        Bewerken<span className="sr-only">, {item.name}</span>
                      </Link>
                      {item.id != 0 && checkAbility('timeregistration', 'update') &&
<></>
                      }
                      </>
                      {item.id == 0 &&
                      <span className="inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-800 ring-1 ring-inset ring-green-600/20">
                        Gefactureerd
                    </span>
                      
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <TablePagination className="mt-2" data={props.data}/>
          </div>
        </div>
      </div>
    </div>
          
          <Drawer data={selectedData} type="customer" key={new Date()}/>

    </>
      );
}
